module.exports = __webpack_public_path__ + "static/media/SearchStreamline.9146a10b.svg";